import { handleApiError, handleApiResponse } from "@/methods/api";
import ApiVerified from "@/services/apiVerified";
import { ApiResponse, InputOption } from "@/types/global";

export default class AiExecutorApi extends ApiVerified {
  async getAiModelOptions(): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.get<Array<InputOption>>(
        `ai-executor/get-ai-model-options`,
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async runCustomAiPrompt(messageContent: string, modelName: string): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.get<any>(`ai-executor/run-custom-ai-prompt`, {
        params: { messageContent: messageContent, modelName: modelName },
      });
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }
}
